import React, { memo, Ref } from 'react';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';
import HBInput from '../HBInput/HBInput';
import { HBInputProps } from '../HBInput/HBInput.types';

export interface HBInputFieldProps
    extends HBBaseFormFieldProps,
        Omit<HBInputProps, 'size'> {
    /** HTML `id` for the field; forwarded to the input and used as the `<label htmlFor>` target. Required. */
    id: string;
    /** Ref forwarded to the underlying HBInput element. */
    inputRef?: Ref<HTMLInputElement>;
}

const HBInputField = ({
    inputRef,
    size = 'sm',
    ...props
}: HBInputFieldProps) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps} size={size}>
            <HBInput
                {...inputProps}
                ref={inputRef}
                size={size}
                required={fieldProps.required}
            />
        </HBBaseFormField>
    );
};

export default memo(HBInputField);
